export default "__VITE_ASSET__BExHMSud__"